import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login/main';
import ClassicLogin from './pages/login/classicLogin';
import Main from './pages/assignments/pages/AssignmentsAndActivities/main';
import Classes from './pages/classes/pages/classRoute';
import MyContent from './pages/myContent/utils/myContentRoute';
import Reports from './pages/reports/utils/reportRoute';
import RequireAuth from './features/authentication/RequireAuth';
import PersistentLogin from './components/PersistentLogin';
import Dashboard from './pages/dashboard/main';
import MyProfile from './pages/myProfile/myProfile';
import ClassRoomView from './pages/assignments/pages/ManageAssign/components/ClassRoomView';
import Responses from './pages/assignments/pages/ManageAssign/components/Responses';
import QuestionsSearch from './pages/questionsSearch/main';
import React from 'react';
import ValidateSSO from './pages/login/validateSSO';
import MethodizeAuthenticateModel from './pages/methodize/pages';

function App() {
  
  return (
    <div>
      <Routes>
        <Route element={<PersistentLogin />}>
          {/* Protected Routes */}
          <Route element={<RequireAuth />} path="/">
            <Route element={<Dashboard />} path="/dashboard/*" />
            <Route element={ <Classes /> } path="/classes/*" />
            <Route element={<Main />} path="/assignments/*" />
            <Route element={<MyContent />} path="/myContent/*" />
            <Route element={<Reports />} path="/reports/*" />
            <Route element={<MyProfile />} path="/myProfile" />
            <Route element={<ClassRoomView />} path="/classroom_view/:id" />
            <Route element={<Responses />} path="/responses/:assignmentId/:studentId" />
            <Route element={<QuestionsSearch />} path="/questionsSearch/*" />
            <Route element={<MethodizeAuthenticateModel />} path="/methodize/*" />
          </Route>
        </Route>

        {/* Public routes */}
        <Route element={<Login />} path="/login/*" />
        {/* <Route element={<ClassicLogin />} path="/login" /> */}
        <Route element={<ClassicLogin/>} path='/classicLogin/:session/:user/:lastAccess/:redirectPage/:logId/:signedInAsId?' />
        <Route element={<ValidateSSO/>} path='/ValidateSSO' />

        {/* Not found routes */}
        <Route elment={<Navigate to="/login" />} path="*" />
      </Routes>
    </div>
  );
}

export default App;
